import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Providers } from '@/providers';
import App from './App';
import './styles/globals.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      {/* 与 #root flex 链配合：占满视口高度，禁止靠子内容撑高祖先 */}
      <div className="flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden">
        <Providers>
          <App />
        </Providers>
      </div>
    </BrowserRouter>
  </StrictMode>,
);

